import { render, staticRenderFns } from "./konnRowSpanGrid.vue?vue&type=template&id=20cb4e2b&scoped=true"
import script from "./konnRowSpanGrid.vue?vue&type=script&lang=js"
export * from "./konnRowSpanGrid.vue?vue&type=script&lang=js"
import style0 from "./konnRowSpanGrid.vue?vue&type=style&index=0&id=20cb4e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb4e2b",
  null
  
)

export default component.exports